import type { ReactNode } from 'react';
import { EmptyState } from '@/components/shared/empty-state';

const messageOf = (error: unknown): string | null => {
  if (error instanceof Error) return error.message;
  return typeof error === 'string' && error.trim() !== '' ? error : null;
};

/** A panel floating on the canvas, for the screens that render without a shell. */
export function CanvasFrame({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden bg-canvas p-2">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-border bg-background">
        {children}
      </div>
    </div>
  );
}

export interface ErrorScreenProps {
  title?: string;
  description?: ReactNode;
  error?: unknown;
  onRetry?: () => void;
  /** Extra escape hatch next to "Reintentar": reload, go back, go home. */
  action?: ReactNode;
}

export function ErrorScreen({
  title = 'Algo se rompió acá',
  description,
  error,
  onRetry,
  action,
}: ErrorScreenProps) {
  const detail = messageOf(error);

  return (
    <EmptyState
      variant="error"
      title={title}
      description={
        <>
          {description ?? 'No pudimos mostrar esta parte de la aplicación.'}
          {detail && (
            <span className="mt-2 block break-words font-mono text-xs text-muted-foreground">
              {detail}
            </span>
          )}
        </>
      }
      {...(onRetry ? { onRetry } : {})}
      {...(action ? { action } : {})}
    />
  );
}
